import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Warranty from "./warranty";
import Consult from "./consult";
import Experience from "./experience";
import SEOMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";

function Center(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <SEOMeta
        title="neat.center, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - neat.center"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, center, neat center, 화상회의"
      />
      <div className={style.device_title_wrap}>
        <div
          className={style.device_subtitle}
          style={{ display: isMobile && "block" }}
        >
          {isMobile ? (
            <>
              360도 카메라와
              <br />
              마이크로{" "}
              <span>
                놓치는 것 없는
                <br />
                완벽한 회의 환경
              </span>
            </>
          ) : (
            <>
              360도 카메라와 마이크로
              <br />
              <span>놓치는 것 없는 완벽한 회의 환경</span>
            </>
          )}
        </div>
        <div className={style.device_title}>
          <img
            className={style.small_title}
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/title_neat_center${isMobile ? "_m" : ""}.webp`
            }
            alt="center"
          />
        </div>
      </div>
      <div className={style.device_text}>회의실 및 대화의 중심</div>

      <div className={style.device_img_list}>
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/center_1${isMobile ? "_m" : ""}.webp`
          }
          alt="center"
        />
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/center_2${isMobile ? "_m" : ""}.webp`
          }
          alt="center"
        />
      </div>

      <div className={style.device_description_wrap}>
        <div
          className={style.device_description_img_box}
          style={{
            paddingTop: "0px",
            justifyContent: "center",
            backgroundColor: isMobile && "#fafafa",
          }}
        >
          <div
            className={style.device_description_img_wrap}
            style={{
              marginBottom: isMobile ? "0px" : "-100px",
              justifyContent: "flex-end",
              gap: "106px",
            }}
          >
            {isMobile ? (
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/device/neat/center_reddot_m.webp"
                }
                alt="reddot"
              />
            ) : (
              <>
                <div className={style.device_description_reddot_wrap}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/device/neat/reddot_2024_white.webp"
                    }
                    alt="reddot"
                  />
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/device/neat/reddot_2024_sp.webp"
                    }
                    alt="reddot"
                  />
                </div>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/device/neat/center_device.webp"
                  }
                  alt="board50"
                />
              </>
            )}
          </div>
          <div className={style.device_description_text_box}>
            테이블 마운트 & 천장 마운트 포함
          </div>
        </div>
        <div className={style.device_description_list_wrap}>
          <div className={style.device_description_list}>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/open${isMobile ? "_m" : ""}.webp`
                  }
                  alt="open"
                />
              </div>
              <div className={style.device_description_text}>
                기본 비디오 장치의{" "}
                <span>성능 확장 · neat 회의장치와 페어링</span>하여 사용
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/360${isMobile ? "_m" : ""}.webp`
                  }
                  alt="360"
                />
              </div>
              <div className={style.device_description_text}>
                <span>360도 카메라와 마이크</span>
                {isMobile ? <br /> : " "}: 완벽한 회의환경 보장
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/tool${isMobile ? "_m" : ""}.webp`
                  }
                  alt="tool"
                />
              </div>
              <div className={style.device_description_text}>
                <span>테이블 위</span>에 올려놓거나 <span>걸어서 배치 </span>
                가능
              </div>
            </div>
          </div>

          <div className={style.device_support_platform_wrap}>
            <div className={style.device_support_platform_title_wrap}>
              <div className={style.device_support_platform_horizon}></div>
              <div className={style.device_support_platform_title}>
                지원 플랫폼
              </div>
            </div>
            <div className={style.device_support_platform_list}>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_zoom_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/zoom_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="zoom"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>ZOOM</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_teams_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/teams_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="teams"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Microsoft Teams</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_vertical_line_wrap}>
        <div className={style.device_vertical_line}></div>
      </div>

      <div className={style.device_features_wrap}>
        <div className={style.device_features_title}>
          Neat Center <span>특장점</span>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {/* {isMobile ? (
                <img
                  className={style.device_features_img_border}
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/device/neat/feature_center_1_m.webp"
                  }
                  alt="feature1"
                />
              ) : (
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/device/neat/feature_center_1.webp"
                  }
                  alt="feature1"
                />
              )} */}
              <video
                className={style.device_features_img_border}
                autoPlay={true}
                muted={true}
                loop={true}
                controls={false}
                src={`${process.env.REACT_APP_CLIENT_URL}video/feature_center_1.mp4`}
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"1".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  최고의 시청각 환경
                </div>
              </div>
              <div className={style.device_features_text}>
                {`Neat Center는 원격회의 참석자가 회의실에 있는 모든 사람을 명확하게 듣고 보고 대화를 더${
                  isMobile ? " " : "\n"
                }` +
                  `자세히 따라 갈 수 있도록 해주는 보조 장치로, 회의실에 있는 사람들이 메인 장치에서 멀리${
                    isMobile ? " " : "\n"
                  }` +
                  `떨어져 있거나, 안쪽을 바라보며 논의할 때도 발언과 표정을 정확하게 포착합니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {isMobile ? (
                <img
                  className={style.device_features_img_border}
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/feature_center_2_m.webp`
                  }
                  alt="feature2"
                />
              ) : (
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/feature_center_2.webp`
                  }
                  alt="feature2"
                />
              )}
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"2".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  더 넓은 비전
                </div>
              </div>
              <div className={style.device_features_text}>
                {`회의실 내 사람들이 주 장치에서 멀리 떨어져 있거나 서로 마주보고 이야기할 때,${
                  isMobile ? " " : "\n"
                }` +
                  `360° 시각 회의 경험을 제공하기 때문에 더 넓은 시야를 확보하게 합니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {isMobile ? (
                <img
                  className={style.device_features_img_border}
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/feature_center_3_m.webp`
                  }
                  alt="feature3"
                />
              ) : (
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/feature_center_3.webp`
                  }
                  alt="feature3"
                />
              )}
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"3".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  더욱 선명한 소리
                </div>
              </div>
              <div className={style.device_features_text}>
                {`16x 마이크 배열로 회의실 내에서 최적의 음성을 픽업하여 원격 참석자들이 대화를 더욱${
                  isMobile ? " " : "\n"
                }` +
                  `명확하게 들을 수 있도록 합니다. 음성은 소리가 발생하는 위치에 따라 Neat Center와${
                    isMobile ? " " : "\n"
                  }` +
                  `주 Neat 장치 사이에서 자동으로 전환됩니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {isMobile ? (
                <img
                  className={style.device_features_img_border}
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/feature_center_4_m.webp`
                  }
                  alt="feature4"
                />
              ) : (
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/feature_center_4.webp`
                  }
                  alt="feature4"
                />
              )}
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"4".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  간단한 설정
                </div>
              </div>
              <div className={style.device_features_text}>
                {
                  "플러그인 네트워크와 전원 케이블 하나만으로 설정과 설치가 간편해집니다."
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_mount_wrap}>
        <div className={style.device_mount_inner_box}>
          <div className={style.device_mount_title_wrap}>
            <div className={style.device_mount_title}>
              Neat Center의 간편한 설치
            </div>
            <div className={style.device_mount_text}>
              {isMobile ? (
                <>
                  Neat Center는
                  <br />
                  PoE 전원 인젝터 포함 여부를 선택할 수 있으며,
                  <br />
                  고정형 또는 자유형 테이블 마운트와
                  <br />
                  천장 마운트 등 다양한 설치 옵션을 제공합니다.
                  <br />
                  Neat Center는 삼각대에 장착하여
                  <br />
                  공간 어디에서나 즉석 배치가 가능합니다.
                </>
              ) : (
                <>
                  Neat Center는 PoE 전원 인젝터 포함 여부를 선택할 수 있으며,
                  <br />
                  고정형 또는 자유형 테이블 마운트와 천장 마운트 등 다양한 설치
                  옵션을 제공합니다.
                  <br />
                  Neat Center는 삼각대에 장착하여 공간 어디에서나 즉석 배치가
                  가능합니다.
                </>
              )}
            </div>
          </div>
          <div className={style.device_mount_type_grid}>
            <div className={style.device_mount_type_item}>
              <div className={style.device_mount_type_title_wrap}>
                <div
                  className={style.device_mount_type_title}
                  style={{
                    width: isMobile ? "fit-content" : "auto",
                    padding: isMobile ? "0 16px" : "0 40px",
                  }}
                >
                  <span>자유형 또는 고정형 테이블 마운트</span>
                </div>
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mount_stand_table_center${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="stand"
              />
            </div>
            <div className={style.device_mount_type_item}>
              <div className={style.device_mount_type_title_wrap}>
                <div
                  className={style.device_mount_type_title}
                  style={{
                    width: isMobile ? "fit-content" : "auto",
                    padding: isMobile ? "0 16px" : "0 38px",
                  }}
                >
                  <span>천장 마운트</span>
                </div>
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mount_top_center${isMobile ? "_m" : ""}.webp`
                }
                alt="top"
              />
            </div>
          </div>
        </div>
      </div>

      <Experience />

      <div className={style.device_spec_wrap}>
        <div className={style.device_spec_title}>제품 사양</div>

        <div className={style.device_size_img_wrap}>
          <div className={style.device_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/spec_center_1${isMobile ? "_m" : ""}.webp`
              }
              alt="spec1"
            />
          </div>
          <div className={style.device_spec_img_wrap}>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_center_2${isMobile ? "_m" : ""}.webp`
                }
                alt="spec2"
              />
            </div>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_center_3${isMobile ? "_m" : ""}.webp`
                }
                alt="spec3"
              />
            </div>
          </div>
        </div>

        <div className={style.device_spec_text_wrap}>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "67px" }}
            >
              <div className={style.device_spec_text_label}>일반</div>
              <div className={style.device_spec_text}>
                <span>360도 뷰를 지원하는 카메라 3대</span>
                <span>마이크 16개</span>
                <span>LED 링 상태 표시기</span>
                <span>보안 잠금 슬롯(Kensington 호환)</span>
                <span>방향 센서(가속도계)</span>
                <span>유연한 장착</span>
                <span>삼각대 마운트 호환(1/4-20 UNC 스레드)</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "40px" }}
            >
              <div className={style.device_spec_text_label}>비디오</div>
              <div className={style.device_spec_text}>
                <span>카메라: 3 x 8 MP, f/2.4 조리개, 162° 수평 시야</span>
                <span>적응형 디지털 줌(최대 4배)</span>
                <span>피사계 심도: 25cm(0.8피트) ~ 무한대</span>
                <span>5미터(16.4피트) 추적 범위로 최적의 이미지 품질 제공</span>
                <span>자동 인물 프레이밍</span>
                <span>하드웨어 가속 비디오 인코딩</span>
                <span>왜곡 보정</span>
                <span>소음 감소</span>
                <span>자동 화이트 밸런스 및 색상 보정</span>
                <span>인물 비디오 해상도: 최대 1080p / 30</span>
              </div>
            </div>
          </div>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "45px" }}
            >
              <div className={style.device_spec_text_label}>
                네트워크 & 포트
              </div>
              <div className={style.device_spec_text}>
                <span>PoE/이더넷</span>
                <span>Wi-Fi(추후 기능 제공예정)</span>
                <span>USB-C(디버그 전용)</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "145px" }}
            >
              <div className={style.device_spec_text_label}>오디오</div>
              <div className={style.device_spec_text}>
                <span>빔포밍 어레이의 마이크 16개</span>
                <span>
                  픽업 범위: 직경5미터(16.5피트) 하드웨어 가속 오디오 처리
                </span>
                <span>에코 제거</span>
                <span>소음 억제</span>
                <span>자동</span>
                <span>게인 제어 반향 제거</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "87px" }}
            >
              <div className={style.device_spec_text_label}>크기 및 무게</div>
              <div className={style.device_spec_text}>
                <span>높이: 11.7인치(297mm)</span>
                <span>너비: 3.3인치(84mm)</span>
                <span>깊이: 3.3인치(84mm)</span>
                <span>무게: 3.24파운드(1.47kg)</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_icon_wrap}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/spec_board50_bg${isMobile ? "_m" : ""}.webp')`,
          }}
        >
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>3</div>
            <div className={style.device_spec_icon_label}>카메라</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>360° FOV</div>
            <div className={style.device_spec_icon_label}>3배 광각 카메라</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.micArray16_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mic_array_16_circle${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mic"
              />
            </div>
            <div className={style.device_spec_icon_label}>16 마이크 어레이</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.framing_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/framing${isMobile ? "_m" : ""}.webp`
                }
                alt="framing"
              />
            </div>
            {isMobile && (
              <div className={style.device_spec_icon_label}>개별 프레이밍</div>
            )}
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>PoE</div>
            <div className={style.device_spec_icon_label}>전원 공급</div>
          </div>

          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.pairing_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/pairing${isMobile ? "_m" : ""}.webp`
                }
                alt="pairing"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              네트워크를 통한{isMobile ? <br /> : " "}페어링
            </div>
          </div>

          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>LED</div>
            <div className={style.device_spec_icon_label}>상태 표시 링</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.refresh_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/refresh${isMobile ? "_m" : ""}.webp`
                }
                alt="refresh"
              />
            </div>
            <div className={style.device_spec_icon_label}>방향 센서</div>
          </div>
        </div>

        <Warranty />
      </div>

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default Center;
